module.exports = __webpack_public_path__ + "img/pencilClear.db15610b.png";